import { sanitizeString } from "app/utils/sanitizeString";

/**
 * Sanitize DSOK customer logo / table image URL strings for forms and API payloads.
 * Strips leading/trailing whitespace, CR/LF, tabs, and other ASCII/C1 control characters.
 *
 * @param {unknown} value
 * @returns {unknown} `null` or `undefined` is returned unchanged; non-strings return `""`.
 */
export function sanitizeLogoUrlString(value) {
  if (value == null) return value;
  if (typeof value !== "string") {
    return "";
  }
  const trimmed = value.trim();
  const cleaned = sanitizeString(trimmed);

  if (
    process.env.NODE_ENV === "development" &&
    cleaned !== trimmed
  ) {
    console.info("[dsok] sanitizeLogoUrlString: stripped control characters", {
      inLen: trimmed.length,
      outLen: cleaned.length,
    });
  }

  return cleaned;
}
